import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Constant, BaseComponent } from '../../../../../infrastructure/common';

import { AuthenticationService } from '../../../../../infrastructure/services/base';

declare var jQuery: any;

@Component({
    moduleId: 'forgot-password',
    templateUrl: './forgot-password.html',
    styles: [`
    body {background-image: url("assets/images/logistic.jpg");}

     .footer {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 60px;
            background-color: #90CAF9 !important;
            z-index: -10 !important;
        }

        .mylogin-box {
            max-width: 330px;
        }
    `]
})

export class ForgotPasswordComponent implements OnInit, AfterViewInit {
    isLoading = false;
    divMessage = '';
    btnSubmitText = 'Submit';
    isSubmitted = false;

    userId: string;
    email: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private authenticationService: AuthenticationService) {}

    ngOnInit() {

    }

    ngAfterViewInit() {
        jQuery('input[name=txtUserName]').focus();
    }

    submit() {
        if (!this.isSubmitted) {
            this.sendEmail();
        } else {
            this.redirectLogin();
        }
    }

    sendEmail() {
        let self = this;
        this.isLoading = true;

        this.authenticationService.sendEmail(this.userId, this.email)
            .subscribe(
                data => {
                    self.isLoading = false;

                    let message = data;
                    if (message && message.MessageType && message.MessageType.Value) {
                        let additionalInfo = message.AdditionalInformation ? '--' + message.AdditionalInformation : '';
                        self.divMessage = '(' + message.MessageNumber + ') ' + message.Message + additionalInfo;

                        if (message.MessageNumber === 3566) {
                            self.btnSubmitText = 'Exit';
                            self.isSubmitted = true;
                        }
                    }
                    else {
                        self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError);
                    }
                },
                error => {
                    self.isLoading = false;
                    self.showMessage(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
                }
            );
    }

    redirectLogin() {
        this.router.navigate(['login']);
    }

    showMessage(title: string, messageNumber: string, message: string, additionalInfo: string = null) {
        jQuery('#PopupMessageTitle').html(title);
        jQuery('#PopupMessageContent').html('(' + messageNumber + ') ' + message + (additionalInfo ? ' -- ' + additionalInfo : ''));
        jQuery('#PopupMessage').modal('show');
    }
}



// WEBPACK FOOTER //
// ./src/app/views/pages/base/security/login/forgot-password.component.ts